import { render, staticRenderFns } from "./HealthSafetyInspectionNotPerformedChart.vue?vue&type=template&id=041a63a0&scoped=true&"
import script from "./HealthSafetyInspectionNotPerformedChart.vue?vue&type=script&lang=ts&"
export * from "./HealthSafetyInspectionNotPerformedChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041a63a0",
  null
  
)

export default component.exports